import React from "react";
import ClientCrudTableRowModal2 from "./ClientCrudTableRowModal2";

const ClientCrudTableModal2 = ({LinesWhitClient,listLines,desvinculedLine}) => {
    return (
        <div className="mt-4">
            <div className="row mb-2">
                <div className="col d-flex align-items-end">
                    <h6>Líneas vinculadas:</h6>
                </div>
                
            </div>
            <div className="table-responsive rounded-3" style={{border:'1px solid black'}}>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" className="text-center">Número de documento</th>
                            <th scope="col" className="text-center">Número de Línea</th>
                            <th scope="col" className="text-center">Tipo de Línea</th>
                            <th scope="col" className="text-center">Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        LinesWhitClient.length > 0 ? LinesWhitClient.map((el, i) => <ClientCrudTableRowModal2 key={el._id} el={el} i={i} desvinculedLine={desvinculedLine}/>) :
                            <tr>
                                <td colSpan="5">Sin datos</td>
                            </tr>
                    }
                    </tbody>
                </table>
            </div>
        </div>
    );
}
export default ClientCrudTableModal2;
